import React from 'react'
import { ClientListContainer } from '@/components/containers/client-list'
import { useTitle } from '@/hooks/use-title'
import BusinessIcon from '@material-ui/icons/Business'

export const ClientListPage: React.FC = () => {
  useTitle('クライアント一覧', <BusinessIcon />)
  return <ClientListContainer />
}
